(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('programa-educativo', {
            parent: 'entity',
            url: '/programa-educativo',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'ProgramaEducativos'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/programa-educativo/programa-educativos.html',
                    controller: 'ProgramaEducativoController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            }
        })
        .state('programa-educativo-detail', {
            parent: 'programa-educativo',
            url: '/programa-educativo/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'ProgramaEducativo'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/programa-educativo/programa-educativo-detail.html',
                    controller: 'ProgramaEducativoDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'ProgramaEducativo', function($stateParams, ProgramaEducativo) {
                    return ProgramaEducativo.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'programa-educativo',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('programa-educativo-detail.edit', {
            parent: 'programa-educativo-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/programa-educativo/programa-educativo-dialog.html',
                    controller: 'ProgramaEducativoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['ProgramaEducativo', function(ProgramaEducativo) {
                            return ProgramaEducativo.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('programa-educativo.new', {
            parent: 'programa-educativo',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/programa-educativo/programa-educativo-dialog.html',
                    controller: 'ProgramaEducativoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('programa-educativo', null, { reload: 'programa-educativo' });
                }, function() {
                    $state.go('programa-educativo');
                });
            }]
        })
        .state('programa-educativo.edit', {
            parent: 'programa-educativo',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/programa-educativo/programa-educativo-dialog.html',
                    controller: 'ProgramaEducativoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['ProgramaEducativo', function(ProgramaEducativo) {
                            return ProgramaEducativo.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('programa-educativo', null, { reload: 'programa-educativo' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('programa-educativo.delete', {
            parent: 'programa-educativo',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/programa-educativo/programa-educativo-delete-dialog.html',
                    controller: 'ProgramaEducativoDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['ProgramaEducativo', function(ProgramaEducativo) {
                            return ProgramaEducativo.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('programa-educativo', null, { reload: 'programa-educativo' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
